import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FilePlus2, Search } from "lucide-react";
import { AiIcon } from "@/components/ui/ai-icon";

// Phone-only bottom action bar (2026-09-29: "mobile view shouldn't look like
// desktop ... add three buttons at the bottom: create resume, improve my
// resume, job search"). Shown on the landing page and in the signed-in app;
// hidden from md: up, and inside the editor / Style Studio, which have their
// own bottom tabs on phones.
const ACTIONS = [
  { key: "create", label: "Create Resume", icon: FilePlus2, to: "/create", match: ["/create"] },
  { key: "improve", label: "Improve Resume", icon: AiIcon, to: "/ats-optimizer", match: ["/ats-optimizer", "/ats-analyzer"] },
  { key: "jobs", label: "Job Search", icon: Search, to: "/jobs", match: ["/jobs"] },
];

export function MobileActionBar({ isLight }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="mobile-action-bar"
      aria-label="Quick actions"
      className={`md:hidden fixed inset-x-0 bottom-0 z-[45] border-t backdrop-blur-xl pb-[env(safe-area-inset-bottom)] ${isLight ? "bg-white/95 border-black/10" : "bg-[#0F211B]/95 border-white/10"}`}
    >
      <div className="grid grid-cols-3">
        {ACTIONS.map(({ key, label, icon: Icon, to, match }) => {
          const active = match.some((m) => pathname.startsWith(m));
          return (
            <button
              key={key}
              type="button"
              data-testid={`mobile-action-${key}`}
              onClick={() => navigate(to)}
              aria-current={active ? "page" : undefined}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-bold transition-colors ${active ? "text-[#A67C52]" : isLight ? "text-[#3D9970]" : "text-[#E3EFE9]"}`}
            >
              <span className={`grid size-9 place-items-center rounded-xl ${key === "create" ? "bg-[#A67C52] text-white shadow-md shadow-[#A67C52]/30" : isLight ? "bg-black/[0.04]" : "bg-white/[0.06]"}`}>
                <Icon className="size-[18px]" />
              </span>
              {label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
